import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from "@apollo/client"
import client from './graphql'
import App from './App';
import './index.scss';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './app/auth/auth';
import theme from './styles/themeConfig';

import  {initialize} from './app/shared/services/analytics';

const container = document.getElementById('root')!;
const root = createRoot(container);

initialize();

root.render(
    <ApolloProvider client={client}>
        <HashRouter>
            <AuthProvider>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </AuthProvider>
        </HashRouter>
    </ApolloProvider>
);

reportWebVitals();